"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FOCUSABLE_ELEMENT_SELECTORS = void 0;
const FOCUSABLE_ELEMENT_SELECTORS = exports.FOCUSABLE_ELEMENT_SELECTORS = ['a:not([disabled])', 'button:not([disabled])', 'input[type=text]:not([disabled])', '[tabindex]:not([disabled]):not([tabindex="-1"])'];